import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { useAppSelector } from '@/store/hooks/redux';
import EmptyImageCard from '../EmptyImageCard';
import { useEffect, useRef } from 'react';

const BidtheatreVideoPreview = () => {
  const videoRef = useRef<HTMLVideoElement>(null);

  const formVideo:any = useAppSelector((state) => state.creativeStepSliceReducer.creativeFormsState.bidtheatre.video.media);
  const timestamp = new Date().getTime();

  useEffect(() => {
    videoRef?.current?.load();
  }, [formVideo?.preSignedUrl]);

  return (
    <Grid container sx={{ overflow: 'hidden' }}>
        <>
          <Box sx={{ maxWidth: '632px', height: '100%', width: '100%' }}>
            {formVideo?.preSignedUrl ? (
              <video ref={videoRef} preload="metadata" style={{ width: '100%', borderRadius: '5px' }} controls>
                <source src={formVideo?.preSignedUrl + '#t=' + timestamp} type="video/mp4" />
              </video>
            ) : (
              <EmptyImageCard></EmptyImageCard>
            )}
          </Box>
          <Grid item xs={12} mb={2}>
            <ul>
              <li> File Type must be MIME: MP4 or MOV </li>
              <li> Video duration must be 15, 20, or 30 seconds </li>
              <li> Video resolution must be 1920x1080. </li>
              <li> Video size limit is 8MB </li>
            </ul>
          </Grid>
        </>
    </Grid>
  );
};

export default BidtheatreVideoPreview;
